<template>
    <div v-wechat-title="title" class="padding10">
        <el-row>
            <el-col :span="4">
                <item-input type="daterange" v-model="rdate" :noPadding="true"></item-input>
            </el-col>
            <el-col :span="20" style="text-align: left;">
                <item-input type="select" style="line-height: 32px; width: 150px;" v-model="dic_ward_id" :options="operation_ward_auth" placeholder="请选择区域"></item-input>
                <item-input type="select" style="line-height: 32px; width: 150px;" v-model="dic_section_id" :options="section_auth" :clearable="true" placeholder="请选择科室"></item-input>
                <item-input type="string" style="width: 150px;" v-model="patient_name" :clearable="true" placeholder="请输入患者姓名"></item-input>
            </el-col>
        </el-row>
                <el-row>

            <el-col :span="20" style="text-align: center;">
                <span class="analgesiaStatus" v-for="status in analgesiaStatus" :key="status.event_state" @click="addStatus(status.event_state)">
                    <i :style="{ background: status.event_color || `#EB9A0D` }" :class="statusChecked && statusChecked.includes(status.event_state)?`el-icon-check`:``"></i>
                    <span>{{ status.event_state }}({{ status.event_num }})</span>&nbsp;&nbsp;&nbsp;
                </span>
            </el-col>
            <el-col class="align-left sfStatus" :span="4">
                <span @click="addSFStatus(1)"><i style="background: var(--primary-color, #009688)" :class="sfChecked == 1 ?`el-icon-check`:``"></i><span>已随访({{ ySF }})</span></span>
                <span @click="addSFStatus(2)"><i style="background: #FFA07A" :class="sfChecked == 2 ?`el-icon-check`:``"></i><span>未随访({{ nSF }})</span></span>
                <el-button style="float: right;margin-right: 10px !important;" type="primary" size="mini" @click="clearLoadSurgeries">刷新</el-button>
            </el-col>
        </el-row>
        <el-row v-if="surgeries && surgeries.length > 0">
            <el-col :xl="defaultAnalgesicSurgeryCount" :md="defaultAnalgesicSurgeryCount" v-for="(p, index) in surgeries" :key="index + '_' + (p.id)" class="padding5">
                <el-card :body-style="{ padding: '5px' }" style="padding-bottom: 5px;">
                    <div class="card-header">
                        <el-row class="height40 padding10 padding-none-v" type="flex" align="middle">
                            <el-col :span="22" style="line-height: 40px">
                                <b style="max-width: 10%;" :title="p.dic_opearting_ward+'/'+p.dic_operating_room+'/'+p.bed_no||'--'">{{ p.dic_opearting_ward }}/{{ p.dic_operating_room }}/{{ p.bed_no||'--' }}</b>
                                &nbsp;&nbsp;
                                <span :style="{'background-color': `${p.analgesic_event_color || `#EB9A0D`}`, 'font-size': `smaller`, color: `white`, padding: `5px`, borderRadius: `5px`}">{{ p.analgesic_event_state }}</span>
                                <span style="float: right">
                                    <b class="fg-primary">{{ p.patient_name }}</b>
                                    {{ `${p.sex || '--'}/${p.age || '--岁'}` }}
                                </span>
                            </el-col>
                            <el-col :span="2" class="align-right" title="查看麻醉单">
                                <span v-if="p.enum_surgery_status >= 30" class="cus-button is-circle el-icon-document" style="background: whitesmoke" @click="loadDocument(p)"></span>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="card-content">
                        <div :style="{ height: `${rowTototalHeight}px` }" wrap-class="scrollbar-wrapper-y">
                            <el-row style="background-color: #F5F6F7;margin-bottom: 10px;">
                                <el-col :span="24" class="padding10">
                                    <el-row>
                                        <el-col :span="12" style="font-size: 16px" class="ellipsis padding-none-h"
                                            ><span class="fg-info textoverflow">科室：</span>{{ p.dic_section || '--' }}</el-col
                                        >
                                        <el-col :span="12" style="font-size: 16px" class="ellipsis padding-none-h"
                                            ><span class="fg-info textoverflow">病区：</span>{{ p.dic_inpatient_section || '--' }}</el-col
                                        >
                                    </el-row>
                                    <el-row style="max-height: 50px" :title="p.diseases || '--'">
                                        <el-col :span="24" style="font-size: 16px" class="ellipsis padding-none-h"
                                            ><span class="fg-info textoverflow">手术诊断：</span>{{ p.diseases || '--' }}</el-col
                                        >
                                    </el-row>
                                    <el-row style="max-height: 50px" :title="p.surgeries || '--'">
                                        <el-col :span="24" style="font-size: 16px" class="ellipsis padding-none-h"
                                            ><span class="fg-info textoverflow">手术名称：</span>{{ p.surgeries || '--' }}</el-col
                                        >
                                    </el-row>
                                    <el-row :title="p.anaes_methods || '--'">
                                        <el-col :span="24" style="font-size: 16px" class="ellipsis padding5 padding-none-h"
                                            ><span class="fg-info textoverflow">麻醉方式：</span>{{ p.anaes_methods || '--' }}</el-col
                                        >
                                    </el-row>
                                    <div style="font-size: 16px;background-color: white !important;padding: 5px 5px 0px 5px;">
                                        <el-row>
                                            <el-col :span="12">
                                                <span style="float: left;">
                                                    镇痛方式：
                                                </span>
                                                <span style="width:60%; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; margin:0 auto;FONT-SIZE: 14px; COLOR: #003399; TEXT-DECORATION: none;float: left;"
                                                :title="p.analgesicRecord && p.analgesicRecord.analgesic_mode">
                                                    {{ p.analgesicRecord && p.analgesicRecord.analgesic_mode || `--` }}
                                                </span>
                                            </el-col>
                                            <el-col :span="12">
                                                <span>
                                                    PCA次数：
                                                </span>
                                                <span>
                                                    {{ p.analgesicRecord && p.analgesicRecord.pcatimes || `--` }}
                                                </span>
                                            </el-col>
                                        </el-row>
                                        <el-row>
                                            <el-col :span="12">
                                                <span>
                                                    开机时间：
                                                </span>
                                                <text-formatter type="datetime" v-model="p.analgesicRecord.analgesia_pump_start_time" v-if="p.analgesicRecord && p.analgesicRecord.analgesia_pump_start_time"></text-formatter>
                                                <span v-else>--</span>
                                            </el-col>
                                            <el-col :span="12">
                                                <span>
                                                    结束时间：
                                                </span>
                                                <text-formatter type="datetime" v-model="p.analgesicRecord.analgesia_pump_end_time" v-if="p.analgesicRecord && p.analgesicRecord.analgesia_pump_end_time"></text-formatter>
                                                <span v-else>--</span>
                                            </el-col>
                                        </el-row>
                                        <el-row>
                                            <el-col :span="12">
                                                <span>
                                                    总&nbsp;&nbsp;容&nbsp;&nbsp;量：
                                                </span>
                                                <span>
                                                    {{ p.analgesicRecord && p.analgesicRecord.total_capacity || `--` }} ml
                                                </span>
                                            </el-col>
                                            <el-col :span="12">
                                                <span>
                                                    持续剂量：
                                                </span>
                                                <span>
                                                    {{ p.analgesicRecord && p.analgesicRecord.continuous_dose || `--` }} ml/h
                                                </span>
                                            </el-col>
                                        </el-row>
                                        <el-row class="textoverflow">
                                            <el-col :span="12">
                                                <span>
                                                    单次剂量：
                                                </span>
                                                <span>
                                                    {{ p.analgesicRecord && p.analgesicRecord.single_dose || `--` }} ml
                                                </span>
                                            </el-col>
                                            <el-col :span="12">
                                                <span>
                                                    首次剂量：
                                                </span>
                                                <span>
                                                    {{ p.analgesicRecord && p.analgesicRecord.first_dose || `--` }} ml
                                                </span>
                                            </el-col>
                                        </el-row>
                                        <el-row class="textoverflow">
                                            <el-col :span="12">
                                                <span>
                                                    最大剂量：
                                                </span>
                                                <span>
                                                    {{ p.analgesicRecord && p.analgesicRecord.maximum_dose_per_hour || `--` }} ml/h
                                                </span>
                                            </el-col>
                                            <el-col :span="12">
                                                <span>
                                                    锁定时间：
                                                </span>
                                                <span>
                                                    {{ p.analgesicRecord && p.analgesicRecord.lock_time || `--` }} min
                                                </span>
                                            </el-col>
                                        </el-row>
                                    </div>
                                    <div class="bottom" style="padding: 0px 5px 5px 5px;text-align: right;background-color: white !important;">
                                        <div v-show="p.end_days" :title="showOutRoomTime(p)" style="float: left;margin-top: 5px;padding: 5px; border: 1px solid;border-radius: 5px;background-color:azure;font-weight: bold;">
                                            术后{{ p.end_days }}天
                                        </div>
                                        <div>
                                            <span v-show="p.analgesicRecord && p.analgesicRecord.follow_up_time" class="fg-primary el-icon-success"></span>
                                            <el-button type="text" @click.prevent="gotoDocument(p)">随访</el-button>
                                            <el-button type="text" @click.prevent="gotoAnalgesic(p)">编辑</el-button>
                                        </div>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <p v-else class="no-surgery">暂无镇痛记录</p>
        <pdf-frame :base64="base64" :visible.sync="pdfvisible" title="麻醉记录单"></pdf-frame>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import pdf from '@/common/vue-pdf-4.1.0'
export default {
    name: `AnalgesicManagement`,
    components: { pdf },
    props: {},
    data() {
        return {
            title: `镇痛管理`,
            dic_section_id: undefined,
            patient_name: ``,
            rdate: [
                this.$moment()
                    .add(-1, `days`)
                    .format(`YYYY/MM/DD HH:mm:ss`),
                this.$moment()
                    .format(`YYYY/MM/DD HH:mm:ss`)
            ],
            defaultAnalgesicSurgeryCount: null,
            surgeries: [],
            analgesiaStatus: [],
            statusChecked: [],
            sfChecked: 0,
            base64: ``,
            pdfvisible: false,
            rowTototalHeight: 0,
            documentList: [],
            ySF: 0,
            nSF: 0,
            newWindow: {},
            windowsOpenLoop: ``,
            o_dic_ward_id: undefined,
            issetoperatingward: false,
            analgesicSearchTimeConfig: this.$root.AnalgesicSearchTimeConfig
        }
    },
    computed: {
        ...mapGetters([`screenHeight`, `screenWidth`, `section_auth`, `active_ward`, `operation_ward_auth`, `business`, `localip/ipAddress`]),
        today() {
            return this.$moment().format(`YYYY/MM/DD dddd `)
        },
        dic_ward_id: {
            get: function() {
                if (!this.issetoperatingward && this.active_ward && this.active_ward.code == `手术区`) {
                    this.o_dic_ward_id = this.active_ward.origion
                }
                return this.o_dic_ward_id
            },
            set: function(v) {
                this.o_dic_ward_id = v
                this.issetoperatingward = true
            }
        }
    },
    mounted() {
        this.$store.dispatch(`ADD_OPERATION_WARD_AUTH`)
        this.$store.dispatch(`ADD_SECTION_AUTH`)
        this.loadDefaultAnalgesicSurgeryCount()
        this.loadSurgeries()
    },
    created() {
        let that = this
        this.loadAnalgesicSearchTimeConfig()
        clearInterval(that.interval)
        that.interval = setInterval(() => {
            that.loadSurgeries()
        }, 100000)
    },
    beforeDestroy() {
        clearInterval(this.interval)
    },
    methods: {
        loadAnalgesicSearchTimeConfig() {
            let beginTime = this.$moment().add(-1, `days`).format(`YYYY/MM/DD HH:mm:ss`)
            if (this.analgesicSearchTimeConfig) {
                let configs = this.analgesicSearchTimeConfig.split(`|`)
                if (configs.length == 2) {
                    beginTime = this.$moment().add(parseInt(configs[0]), `days`).format(`YYYY/MM/DD`) + ` ${configs[1]}`
                }
            }
            console.log(`beginTime`)
            console.log(beginTime)
            let endTime = this.$moment().format(`YYYY/MM/DD HH:mm:ss`)
            this.rdate = [beginTime, endTime]
        },
        showOutRoomTime(p) {
            let outTime = this.$moment(p.fact_outRoom_time).format(`YYYY-MM-DD HH:mm:ss`)
            return `手术结束时间：${outTime}`
        },
        clearLoadSurgeries() {
            this.dic_section_id = undefined
            this.patient_name = ``
            this.statusChecked = []
            this.sfChecked = 0
        },
        addStatus(status) {
            let that = this
            if (_.includes(that.statusChecked, status)) {
                that.statusChecked = _.filter(that.statusChecked, d => {
                    return d != status
                })
            } else {
                that.statusChecked.push(status)
            }
            console.log(that.statusChecked)
        },
        addSFStatus(status) {
            let that = this
            if (status == that.sfChecked) {
                that.sfChecked = 0
            } else {
                that.sfChecked = status
            }
            console.log(that.sfChecked)
        },
        loadDefaultAnalgesicSurgeryCount() {
            // TODO:获取参数配置中默认镇痛手术床卡数量
            let that = this
            let req = this.myaxios.get(`api/AcisSystem/Config/GetByKey?key=DefaultAnalgesicSurgeryCount`) // 获取参数信息
            req.then(data => {
                if (data) {
                    var count = 0
                    if (data.value > 4) {
                        count = 4
                    } else if (data.value <= 0) {
                        count = 1
                    } else {
                        count = parseInt(data.value)
                    }
                    that.defaultAnalgesicSurgeryCount = 24 / count
                } else {
                    that.defaultAnalgesicSurgeryCount = 8
                }
            }).catch(e => {})
        },
        loadSurgeries() {
            let that = this
            that.surgeries = []
            if (!that.active_ward || !that.active_ward.groupId) {
                return
            }
            let hospitalWardId = that.active_ward.groupId
            console.log(`dic_ward_id`, this.dic_ward_id)
            // 获取开始时间
            var begin = this.$moment(this.rdate[0]).format(`YYYY/MM/DD 00:00:00`)
            // 获取结束时间
            var end = this.$moment(this.rdate[1]).format(`YYYY/MM/DD 23:59:59`)
            let req = this.myaxios.get(`api/AcisSystem/AnalgesicRecord/GetAllSurgeriesByHospitalWard?hospitalWardId=${hospitalWardId}&dic_ward_id=${that.dic_ward_id || 0}&sectionId=${that.dic_section_id || 0}&from=${begin}&to=${end}`)
            req.then(data => {
                console.log(`data`, data)
                if (data != null) {
                    if (that.patient_name) {
                        data = _.filter(data, d => {
                            return _.includes(d.patient_name, that.patient_name)
                        }) || []
                    }
                    that.ySF = (_.filter(data, d => {
                        return d.analgesicRecord && d.analgesicRecord.follow_up_time
                    }) || []).length
                    that.nSF = (_.filter(data, d => {
                        return !d.analgesicRecord || !d.analgesicRecord.follow_up_time
                    }) || []).length
                    let info = _.filter(data, d => {
                        return d.analgesic_event_state
                    })
                    that.analgesiaStatus = _.reduce(
                        _.groupBy(info, `analgesic_event_state`)
                        , function(result, v, key) {
                            result.push({
                                event_state: key,
                                event_color: v[0].analgesic_event_color,
                                event_num: v.length,
                                display_order: v[0].analgesic_event_display_order
                            })
                            return result
                        }, [])
                    that.analgesiaStatus = that.analgesiaStatus.sort((a, b) => a.display_order - b.display_order)
                    console.log(that.analgesiaStatus)

                    // 分组过滤
                    that.surgeries = _.cloneDeep(data)
                    if (that.statusChecked && that.statusChecked.length > 0) {
                        that.surgeries = _.filter(that.surgeries, d => {
                            return _.includes(that.statusChecked, d.analgesic_event_state)
                        }) || []
                    }
                    if (that.sfChecked == 1) {
                        that.surgeries = _.filter(that.surgeries, d => {
                            return d.analgesicRecord && d.analgesicRecord.follow_up_time
                        }) || []
                    } else if (that.sfChecked == 2) {
                        that.surgeries = _.filter(that.surgeries, d => {
                            return d.analgesicRecord && !d.analgesicRecord.follow_up_time
                        }) || []
                    }
                    console.log(that.surgeries)
                }
            }).catch(e => {})
        },
        loadDocument(p) {
            let req = this.myaxios.post(`/api/Operation/Home/ExportPdf?surgeryInfoId=${p.id}&recordType=1`)
            req.then(data => {
                this.pdfvisible = true
                this.base64 = data
            }).catch(e => console.log(e))
        },
        gotoDocument(surgery) {
            console.log(this.business)
            let menuName = `document2`
            let r = _.find(this.business, t => {
                return t.business_level == `M004` && t.location == menuName
            })
            if (!r) {
                this.$message.error(`患者管理没有配置 ${menuName} 页面,请配置菜单和工作栏`)
            } else {
                let menuInfo = _.cloneDeep(r)
                let rurl = menuInfo.url
                if (rurl) {
                    let docId = this.$root.DOCUMENT[`ZTSF001`]
                    rurl += rurl.indexOf(`?`) > -1 ? `&` : `?`
                    rurl = `${rurl}&docId=${docId}&isOnly=1`
                    menuInfo.url = rurl
                    this.openUrl(menuInfo, surgery)
                } else {
                    console.log(`菜单`, menuInfo)
                    this.$message.error(`请检查患者文书菜单配置`)
                }
            }
        },
        gotoAnalgesic(surgery) {
            console.log(this.business)
            let menuName = `analgesic`
            let r = _.find(this.business, t => {
                return t.business_level == `M003` && t.location == menuName
            })
            if (!r) {
                this.$message.error(`患者管理没有配置 ${menuName} 页面,请配置菜单和工作栏`)
            } else {
                let menuInfo = _.cloneDeep(r)
                this.openUrl(menuInfo, surgery)
            }
        },
        openUrl(menuInfo, surgery) {
            let that = this
            console.log(menuInfo)
            let url = (menuInfo && menuInfo.url) || `/`
            // 第三方链接直接弹框打开，不用二次弹框打开
            if (url.indexOf(`source=`) > -1) {
                url = decodeURIComponent(url.split(`source=`)[1])
                url += url.indexOf(`?`) > -1 ? `&` : `?`
                url = `${url}surgery_id=${surgery.id}&isOnlyShowMain=true&workbar=${menuInfo.workbar}&record_type=1`
                this.windowOpenUrl(surgery.id, url)
            } else {
                // 本系统页面链接，直接调用患者管理路由加载界面
                url += url.indexOf(`?`) > -1 ? `&` : `?`
                url = `${url}surgery_id=${surgery.id}&isOnlyShowMain=true&workbar=${menuInfo.workbar}&record_type=1`
                let routeUrl = this.$router.resolve({
                    path: url
                })
                let token = sessionStorage.getItem(`token`)
                let r = `${routeUrl.href}&token=${encodeURIComponent(token)}`
                // 打开新页面并传递凭据
                // eslint-disable-next-line no-undef
                if (typeof cordova != `undefined`) {
                    // eslint-disable-next-line no-undef
                    that.newWindow = cordova.InAppBrowser.open(
                        r,
                        `_blank`,
                        `toolbar=no,zoom=no`
                    )
                    // 添加事件监听
                    that.newWindow.addEventListener(`exit`, this.onExit)
                } else {
                    var w = this.screenWidth - 10
                    var h = this.screenHeight - 10
                    that.newWindow = window.open(routeUrl.href, ``, `width=${w},height=${h},top=10,left=10`)
                    if (!that.windowsOpenLoop) {
                        that.windowsOpenLoop = setInterval(() => {
                            if (that.newWindow.closed) {
                                clearInterval(that.windowsOpenLoop)
                                that.windowsOpenLoop = ``
                                that.loadSurgeries() // 重新请求页面数据
                            }
                        }, 1000)
                    }
                }
            }
        },
        onExit() {
            // 在需要的时候移除事件监听
            this.loadSurgeries() // 重新请求页面数据
            this.newWindow.removeEventListener(`exit`, this.onExit)
        },
        print(surgery) {
            let req2 = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=isShowSendPrintMessage`)
            req2.then(isShow => {
                this.$store.dispatch(`PRINT_PDF`, {
                    host: this.$root.DOCSERVICE_BASE,
                    params: Object.assign(
                        {
                            docid: this.$root.DOCUMENT[`ZTSF001`],
                            id1: surgery.id,
                            objId: ``,
                            from: this.$moment().format(`YYYYMMDDHHmm`),
                            to: this.$moment().format(`YYYYMMDDHHmm`)
                        },
                        { isShowSendPrintMessage: isShow.value }
                    )
                })
            }).catch(e => {
                console.log(e)
            })
        }
    },
    watch: {
        active_ward: function() {
            this.loadSurgeries()
        },
        dic_section_id: function() {
            this.loadSurgeries()
        },
        dic_ward_id: function() {
            this.loadSurgeries()
        },
        patient_name: function() {
            this.loadSurgeries()
        },
        statusChecked: function() {
            this.loadSurgeries()
        },
        sfChecked: function() {
            this.loadSurgeries()
        },
        rdate: function() {
            this.loadSurgeries()
        }
    }
}
</script>
<style  lang="less" scoped>
.sfStatus {
    display: inline-block;
    height: 30px;
    font-size: 15px;
    font-family: Microsoft YaHei;
    font-weight: 600;
    line-height: 30px;
    color: #333333;
    opacity: 1;
    i {
        width: 16px;
        height: 16px;
        display: inline-block;
        border-radius: 50%;
        vertical-align: middle;
    }
}
.analgesiaStatus {
    font-size: 25px;
    font-weight: bold;
    font-family: Microsoft YaHei;
    display: inline-block;
    color: #333333;
    opacity: 1;
    i {
        width: 20px;
        height: 20px;
        display: inline-block;
        border-radius: 50%;
        vertical-align: middle;
    }
}
.textoverflow {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.card-header {
    // line-height: 24px;
    text-align: left;
    font-size: 18px;
    font-family: Arial;
    /*background: darkkhaki;*/
}
.card-header-dialog {
    // line-height: 24px;
    text-align: left;
    font-size: 24px;
    font-family: Arial;
    /*background: darkkhaki;*/
}
/deep/ .el-dialog__body {
    padding: 20px 20px 0 20px !important;
    overflow: auto;
    background: #fafafa;
    height: 85vh;
}
/deep/.el-dialog__body .div {
    height: auto;
}
.fontClass {
    font-size: 28px;
}
.fontBClass {
    font-size: 38px;
}
// .tag-border {
//     border: 1px solid rgb(42, 52, 190);
// }
.card-content {
    // padding: 14px;
    height: 100%;
    text-align: left;
    background: #F5F6F7;
    .hand {
        font-size: 14px;
        // color:darkgray;
    }
    .dt {
        color: darkgoldenrod;
    }
    .el-row {
        padding: 2px !important;
    }
    //  .el-col {
    //   padding: 0 !important;
    // }
}
.card-content-dialog {
    // padding: 14px;
    height: 100%;
    text-align: left;
    .hand {
        font-size: 14px;
        // color:darkgray;
    }
    .dt {
        color: darkgoldenrod;
    }
    .el-row {
        padding: 8px !important;
    }
    //  .el-col {
    //   padding: 0 !important;
    // }
}
h1 {
    text-align: left;
    padding: 0;
    font-size: 30px;
    margin: 0;
}
.no-surgery {
    line-height: 600px;
    font-size: 24px;
    opacity: 0.5;
}
.no-bed {
    background: gainsboro;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: lightgrey;
    font-size: 100px;
    background: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/Analgesic/AnalgesicManagement.vue